import { ActionTypes } from "../type";

const initialState ={
    zone:null
}

export const zoneReducer = (state=initialState,action)=>{
    switch (action.type){
        case ActionTypes.ZONE:
            return {...state,zone:action.payload}
        default:
            return state;
    }
}